﻿module.exports = function ($, masonry, urlParameters) {
    return {
        init: function () {
            if ($("body.news").length > 0 || $(".furtherReading").length > 0) {
                var msnry = new masonry(".newsGrid",
                {
                    // options
                    itemSelector: ".grid-item",
                    columnWidth: ".grid-sizer",
                    percentPosition: true
                });
            }

            if ($("body.news").length > 0) {


                $(".newsNavigation:first").parent().parent().clone(true).addClass("mobile-tablet-only")
                    .insertAfter($(".grid:first"));
                $(".newsNavigation").parent().parent().not($(".mobile-tablet-only")).addClass("hide-mobile-tablet");


                // Set the click events on the previous and next buttons
                $(".resourceSearch__results__pagination .prev").click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var page = parseInt($("#page").val()) - 1;
                    if (page > 0) {
                        $("#page").val(page);
                        urlParameters.addParam("page", $("#page").val(), true, false);
                    }
                });

                $(".resourceSearch__results__pagination .next").click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var page = parseInt($("#page").val()) + 1;
                    if (page <= $("#pagination").data("pages")) {
                        $("#page").val(page);
                        urlParameters.addParam("page", $("#page").val(), true, false);
                    }
                });

                var selectedPage = parseInt($('#page').val());
                var pages = parseInt($("#pageCount").val());
                var startPage = Math.max(selectedPage - 3, 1);
                var endPage = Math.min(selectedPage + 3, pages);

                $("#pagination").empty();
                $("#pagination").data('pages', pages);
                for (var page = startPage; page <= endPage; page++) {
                    var selected = selectedPage === page;
                    $('#pagination').append("<a href=\"#" +
                        page +
                        "\" class=\"pagination__link " +
                        (selected ? "selected" : "") +
                        "\">" +
                        (page < 10 ? "0" + page : page) +
                        "</a>");
                }
                $(".resourceSearch__results__pagination").show();
                $("#pagination .pagination__link").click(function(e) {
                    e.preventDefault();
                    if (!$(this).hasClass('selected')) {
                        $("#page").val($(this).attr("href").replace("#", ""));
                        urlParameters.addParam("page", $("#page").val(), true, false);
                    }
                });


                $(".resourceSearch__results__footer").css("visibility", "visible");
            }
        }
    }
} 